<template>
  <div class="list-container">
    <div class="top-fix-area" ref="topFixArea">
      <h1 class="page-title">業者マスタ情報一覧</h1>
      <div class="mb-2">
      <router-link
        v-if="userRole == 0 || userRole == 999"
        :to="{ path: '/create-vendor', query: getSearchQuery() }"
        class="btn btn-sm btn-primary me-2"
      >
        業者マスタ情報作成
      </router-link> <!-- 業者マスタ情報作成ページへのリンク -->

        <!-- Button trigger modal -->
        <button v-if="userRole == 999" type="button" class="btn btn-sm btn-primary me-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
          CSVインポート
        </button>
  
        <!-- Button trigger modal -->
        <button type="button" class="btn btn-sm btn-primary me-2" @click="downloadCsv">CSVエクスポート</button>

        <button class="btn btn-sm btn-outline-secondary" @click="isSearchExpanded = !isSearchExpanded">
          {{ isSearchExpanded ? '検索条件を非表示' : '検索条件を表示' }}
        </button>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="exampleModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">CSVインポート</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="clearErrorMessages"></button>
            </div>
            <div class="modal-body">
              <div v-if="errorMessages" >
                <div class="error-massage-item" v-for="errorMessage in errorMessages" :key="errorMessage.id">
                  <p class="alert alert-danger mt-2">{{ errorMessage.row_num }}行目：{{errorMessage.messages[0]}}</p>
                </div>
              </div>

              <div class="my-3">
                <p>業者情報CSVファイル選択</p>
                <input type="file" class="form-control" @change="handleFileChange">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="clearErrorMessages">閉じる</button>
              <button type="button" class="btn btn-primary" @click="submitFile">インポート</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 検索バーの追加 -->
      <SearchPanelWrapper :key="route.fullPath" v-model="isSearchExpanded" :getTableElement="() => tableWrapper?.$el || tableWrapper?.value" >
        <form class="search-container" style="background-color: #f8f9fa;" @submit.prevent="searchVendors"> <!-- 背景色を薄く設定 -->
          <div class="row g-3 align-items-center">
            <div class="col-auto">
              <label for="searchName" class="col-form-label">業者名</label>
            </div>
            <div class="col-auto">
              <input type="text" id="searchName" class="form-control" v-model="searchName" placeholder="業者名で検索">
            </div>

            <DeletedStatusSelect v-model="searchDeletedStatus" id="vendorDeletedStatus" />

            <div class="col-auto">
              <button type="submit" class="btn btn-sm btn-primary mx-1">検索</button>
              <button type="button" class="btn btn-sm btn-secondary mx-1" @click="searchResetVendors">クリア</button>
            </div>
          </div>
        </form>
      </SearchPanelWrapper>
    </div>

    <div class="d-flex justify-content-end" ref="paginationContainer">
      <Pagination
        :currentPage="currentPage"
        :totalPages="totalPages"
        @change-page="handleChangePage"
      />
    </div>

    <div class="table-wrapper" ref="tableWrapper">
      <table class="master-table table table-bordered">
        <thead class="table-dark">
          <tr>
            <th class="text-nowrap">ID</th>
            <th class="text-nowrap">法人番号</th>
            <th class="text-nowrap">業者名</th>
            <th class="text-nowrap">郵便番号</th>
            <th class="text-nowrap">住所</th>
            <th class="text-nowrap">メールアドレス</th>
            <th class="text-nowrap">電話番号</th>
            <th class="text-nowrap">FAX</th>
            <th class="btn-cell"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="vendor in vendors" :key="vendor.id" :class="{ 'no-active-vendor': vendor.del_flg == 1 }">
            <td class="text-nowrap">{{ vendor.id }}</td>
            <td class="text-nowrap">{{ vendor.corp_no }}</td>
            <td class="text-nowrap">{{ vendor.vendor_nm }}</td>
            <td class="text-nowrap">{{ vendor.postal_code }}</td>
            <td class="text-nowrap">{{vendor.prefecture}}{{vendor.city}}{{vendor.other_address}}</td>
            <td class="text-nowrap">{{ vendor.email }}</td>
            <td class="text-nowrap">{{ vendor.tel_num }}</td>
            <td class="text-nowrap">{{ vendor.fax }}</td>
            <td  class="btn-cell text-nowrap">
              <router-link :to="{ name: 'VendorDetail', params: { id: vendor.id }, query: getSearchQuery() }"> <!-- 業者情報詳細ページへのリンク -->
                <button type="button" class="btn btn-sm btn-info me-2">詳細</button>
              </router-link>

              <router-link v-if="userRole == 0 || userRole == 999" :to="{ name: 'VendorEdit', params: { id: vendor.id }, query: getSearchQuery() }"> <!-- 業者情報編集ページへのリンク -->
                <button type="button" class="btn btn-sm btn-success me-2">編集</button>
              </router-link>

              <button v-if="vendor.del_flg == 0 && (userRole == 0 || userRole == 999)" class="btn btn-sm btn-danger" data-bs-toggle="modal" data-bs-target="#deleteModal" @click="handleDeleteClick(vendor.id)">削除</button>
              <button v-if="vendor.del_flg == 1 && (userRole == 0 || userRole == 999)" class="btn btn-sm btn-warning" data-bs-toggle="modal" data-bs-target="#restoreModal" @click="handleRestoreClick(vendor.id)">復元</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 削除確認モーダル -->
    <DeleteConfirmationModal
      :paramsId="paramsIdToDelete"
      @confirmDelete="handleConfirmDelete"
    />

    <!-- 復元確認モーダル -->
    <RestoreConfirmationModal
      :paramsId="paramsIdToRestore"
      @confirmRestore="handleConfirmRestore"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import {
  getVendors,
  deleteVendor,
  restoreVendor,
  exportVendorsCsv,
  importVendorsCsv
} from '@/api/axios';
import { Modal } from 'bootstrap';
import SearchPanelWrapper from '@/components/searchPanels/SearchPanelWrapper.vue';
import DeleteConfirmationModal from '@/components/shared/DeleteConfirmationModal.vue';
import RestoreConfirmationModal from '@/components/shared/RestoreConfirmationModal.vue';
import Pagination from '@/components/shared/Pagination.vue';
import DeletedStatusSelect from '@/components/shared/DeletedStatusSelect.vue';

export default {
  components: {
    SearchPanelWrapper,
    DeleteConfirmationModal,
    RestoreConfirmationModal,
    Pagination,
    DeletedStatusSelect
  },
  setup() {
    const title = ref('業者情報一覧');

    watchEffect(() => {
      document.title = title.value;
    });

    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const userRole = computed(() => store.state.userRole);
    const vendors = ref([]);
    const selectedFile = ref(null);

     // エラーメッセージ用のリアクティブプロパティ
    const errorMessages = ref({});

    // 検索用のデータプロパティ
    const searchName = ref('');
    const searchDeletedStatus = ref('active');

    // 削除モーダルへ渡すID
    const paramsIdToDelete = ref(null);

    // 復元モーダルへ渡すID
    const paramsIdToRestore = ref(null);

    // テーブルの高さの動的な設定
    const topFixArea = ref(null);
    const tableWrapper = ref(null);
    const paginationContainer = ref(null);

    // 検索パネルの展開状態を管理するためのリアクティブプロパティ
    const isSearchExpanded = ref(true);

    // ▼▼ 共通：検索条件をそのまま query として返す ▼▼
    const getSearchQuery = () => ({
      vendor_name: searchName.value,
      vendor_deleted_status: searchDeletedStatus.value,
      vendor_page: currentPage.value || 1
    });

    // ページネーション
    const currentPage = ref(1);
    const totalPages = ref(20); // トータルページ数を管理するためのプロパティ

    const fetchVendors = async (page = 1) => {
      try {
        const response = await getVendors({
          name: searchName.value,
          deleted_status: searchDeletedStatus.value,
          page: page
        });
        vendors.value = response.data.vendors;
        totalPages.value = response.data.meta.total_pages;
        currentPage.value = response.data.meta.current_page;
      } catch (error) {
        console.error('業者情報ーデータの取得に失敗しました:', error);
      }
    };

    const handleChangePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        fetchVendors(page);

        const q = getSearchQuery();
        q.vendor_page = page;

        router.replace({
          path: '/vendors',
          query: q
        });

        // スクロールを tableWrapper のトップへ
        if (tableWrapper.value) {
          tableWrapper.value.scrollTop = 0;
        }
      }
    };

    // 削除ボタンクリック
    const handleDeleteClick = (vendorId) => {
      paramsIdToDelete.value = vendorId;
    };

    // 削除処理
    const handleConfirmDelete = async (vendorId) => {
      try {
        await deleteVendor(vendorId);
        store.dispatch('setFlashMessage', { message: '業者情報が削除されました', type: 'success' });
        
        // vendors のデータを再取得
        await fetchVendors(currentPage.value);

      } catch (error) {
        // エラー処理
        store.dispatch('setFlashMessage', { message: '業者情報削除に失敗しました', type: 'danger' });
      }
    };

    // 復元ボタンクリック
    const handleRestoreClick = (vendorId) => {
      paramsIdToRestore.value = vendorId;
    };

    // 復元処理
    const handleConfirmRestore = async (vendorId) => {
      try {
        await restoreVendor(vendorId);
        store.dispatch('setFlashMessage', { message: '業者情報が復元されました', type: 'success' });
        
        // vendors のデータを再取得
        await fetchVendors(currentPage.value);

      } catch (error) {
        // エラー処理
        store.dispatch('setFlashMessage', { message: '業者情報復元に失敗しました', type: 'danger' });
      }
    };

    // CSVエクスポート
    const downloadCsv = async () => {
      try {
        const response = await exportVendorsCsv({
          name: searchName.value,
          deleted_status: searchDeletedStatus.value
        });

        // 現在の年月日時分秒を取得してフォーマット
        const now = new Date();
        const timestamp = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, "0")}${now.getDate().toString().padStart(2, "0")}_${now.getHours().toString().padStart(2, "0")}${now.getMinutes().toString().padStart(2, "0")}${now.getSeconds().toString().padStart(2, "0")}`;

        const fileName = `m_vendors_${timestamp}.csv`; // 動的なファイル名

        // CSVファイルをダウンロード
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("CSVダウンロードエラー", error);
      }
    };

    // CSVインポート
    const handleFileChange = (event) => {
      selectedFile.value = event.target.files[0]; // 選択されたファイルを保存
    };

    // モーダルを閉じる処理
    const closeModal = () => {
      const modalElement = document.getElementById('exampleModal');
      const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
      modal.hide();
    };

    // モーダルが閉じた後に実行される処理
    const onModalHidden = () => {
      clearErrorMessages(); // エラーメッセージをクリアする関数を呼び出す
    };

    // モーダルの閉じるボタンのアクション
    const clearErrorMessages = () => {
      errorMessages.value = {}; // エラーメッセージをクリア
      selectedFile.value = null; // ファイルをクリア

      // inputタグのvalueをリセット
      const input = document.querySelector('.form-control[type="file"]');
      if (input) {
        input.value = '';
      }
    };

    const submitFile = async () => {
      if (!selectedFile.value) {
        store.dispatch('setFlashMessage', { message: 'ファイルが選択されていません', type: 'danger' });
        return;
      }

      try {
        await importVendorsCsv(selectedFile.value); // 選択されたファイルを関数に渡す
        store.dispatch('setFlashMessage', { message: 'アップロードに成功しました', type: 'success' });
        // モーダルを閉じる
        closeModal();

        // モーダルが完全に閉じた後に実行されるイベントリスナーを追加
        document.getElementById('exampleModal').addEventListener('hidden.bs.modal', onModalHidden);

        // 業者情報の再取得
        await fetchVendors();
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }
        console.error('アップロードに失敗しました', error);
        store.dispatch('setFlashMessage', { message: 'アップロードに失敗しました', type: 'danger' });
      }
    };

    // 業者を検索するメソッド
    const searchVendors = async () => {
      await fetchVendors(1);

      const q = getSearchQuery();
      q.vendor_page = 1;

      router.push({
        path: '/vendors',
        query: q
      });
    };

    // 業者を検索リセットするメソッド
    const searchResetVendors = async () => {
      searchName.value = ''; // 名前検索条件をクリア
      searchDeletedStatus.value = 'active';
      await fetchVendors(1);

      const q = getSearchQuery();
      q.vendor_page = 1;

      router.replace({
        path: '/vendors',
        query: q
      });
    };

    // ▼▼▼ クエリパラメータから検索条件を復元 ▼▼▼
    onMounted(() => {
      const q = route.query;

      searchName.value = q.vendor_name || '';
      searchDeletedStatus.value = q.vendor_deleted_status || 'active';
      currentPage.value = q.vendor_page ? Number(q.vendor_page) : 1;

      fetchVendors(currentPage.value);
    });

    return {
      title,
      route,
      userRole,
      vendors,
      paramsIdToDelete,
      handleDeleteClick,
      handleConfirmDelete,
      handleRestoreClick,
      paramsIdToRestore,
      handleConfirmRestore,
      downloadCsv,
      selectedFile,
      handleFileChange,
      submitFile,
      errorMessages,
      clearErrorMessages,
      searchName,
      searchDeletedStatus,
      getSearchQuery,
      currentPage,
      totalPages,
      handleChangePage,
      searchVendors,
      searchResetVendors,
      isSearchExpanded,
      topFixArea,
      tableWrapper,
      paginationContainer
    };
  }
};
</script>

<style scoped>
.no-active-vendor td{
  background-color: #aaa;
}
</style>
